import i18n from "../providers/LocaleProvider";

export const updateLanguage = (locale) => {
   const formatted = locale.toLowerCase();
   i18n.changeLanguage(formatted);
};
